export default "__VITE_ASSET__BDlOwjCd__"